export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide mb-4">
              Getting Started
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-6">
              What Is Vigorbuy Spreadsheet?
            </h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed">
              <p>
                <strong>Vigorbuy Spreadsheet</strong> is a versatile spreadsheet platform designed to help businesses and individuals streamline data management, financial tracking, and productivity workflows. Built with both beginners and power users in mind, it combines the familiarity of traditional spreadsheet interfaces with modern collaboration features.
              </p>
              <p>
                Whether you are managing inventory for your online store, tracking monthly budgets, organizing project timelines, or analyzing sales data, Vigorbuy Spreadsheet provides the tools and templates you need to work smarter. Its intuitive interface reduces the learning curve while maintaining the depth required for complex data operations.
              </p>
              <p>
                Thousands of professionals across e-commerce, finance, education, and small business sectors rely on Vigorbuy Spreadsheet daily. The platform supports real-time collaboration, automated calculations, customizable templates, and seamless data import/export — making it a practical choice for modern teams.
              </p>
            </div>

            <div className="mt-6 flex flex-wrap gap-3">
              {['Business Management', 'Financial Tracking', 'Inventory Control', 'Data Organization'].map((tag) => (
                <span key={tag} className="px-3 py-1.5 rounded-lg bg-background-100 text-xs font-medium text-foreground-600 border border-background-200/60">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautifully%20organized%20modern%20desk%20setup%20with%20a%20large%20monitor%20showing%20colorful%20spreadsheet%20dashboard%20with%20multiple%20charts%20graphs%20and%20data%20tables%20in%20warm%20tones%2C%20next%20to%20the%20monitor%20sits%20a%20cream%20ceramic%20coffee%20mug%20a%20small%20potted%20green%20plant%20with%20round%20leaves%20and%20a%20leather%20bound%20notebook%20with%20brass%20pen%2C%20soft%20natural%20daylight%20from%20a%20nearby%20window%2C%20warm%20beige%20cream%20and%20subtle%20sage%20accents%2C%20editorial%20lifestyle%20photography%20with%20clean%20minimalist%20composition%20and%20gentle%20shadows&width=800&height=600&seq=whatis-vigorbuy-new-v2-2026&orientation=landscape"
                alt="Vigorbuy Spreadsheet dashboard on modern desk setup"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-2xl bg-accent-100 flex items-center justify-center hidden lg:flex">
              <i className="ri-file-chart-line text-2xl text-accent-600"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}